import {isNotStringOrEmptyString} from "@utils/string";
import {isInLabelValueArrayAsString, isValidPositiveNumber} from "@utils/validators";
import {
   MOTOR_CYCLE_KEEPER_OPTIONS,
   MOTOR_CYCLE_OWNER_OPTIONS, MOTOR_CYCLE_PARKING_OPTIONS,
   YES_NO_CHOICE_OPTIONS
} from "@constants/dropdown-choices";
import {isDateGreaterThenToday} from "@utils/date-time";

export const ValidateStep3Data = (data) => {

    const msgList = [];
    
    if(isNotStringOrEmptyString(data.bikeRegNumber)) {
       msgList.push({
          name: `bikeRegNumber`,
          message: `Please specify the bike registration number`
       });
    }
    
    if(isNotStringOrEmptyString(data.bikeManufacturer)) {
       msgList.push({
          name: `bikeManufacturer`,
          message: `Please specify the bike manufacturer`
       });
    }

    if(isNotStringOrEmptyString(data.bikeModel)) {
       msgList.push({
          name: `bikeModel`,
          message: `Please specify the bike model`
       });
    }
   
      if(isNotStringOrEmptyString(data.bikeYear)) {
         msgList.push({
            name: `bikeYear`,
            message: `Please specify the bike year`
         });
      } else if(!isValidPositiveNumber(data.bikeYear) || (data.bikeYear < 1990 || data.bikeYear > (new Date()).getFullYear())) {
         msgList.push({
            name: `bikeYear`,
            message: `The bike year must be a valid year number!`
         });
      }
      
      if(!isInLabelValueArrayAsString(data.isFittedWithSideCar,YES_NO_CHOICE_OPTIONS)) {
         msgList.push({
            name: `isFittedWithSideCar`,
            message: `Please specify if the bike is fitted with a side car`
         });
      }
      
      if(!isInLabelValueArrayAsString(data.isImported,YES_NO_CHOICE_OPTIONS)) {
         msgList.push({
            name: `isImported`,
            message: `Please specify if the bike is imported`
         });
      }
      
      if(!isInLabelValueArrayAsString(data.hasModifications,YES_NO_CHOICE_OPTIONS)) {
         msgList.push({
            name: `hasModifications`,
            message: `Please specify if the bike has modifications`
         });
      }
      
      if(!isInLabelValueArrayAsString(data.hasSecurityDeviceFitted,YES_NO_CHOICE_OPTIONS)) {
         msgList.push({
            name: `hasSecurityDeviceFitted`,
            message: `Please specify if the bike has a security device fitted`
         });
      }
      
      if(isNotStringOrEmptyString(data.bikeMarketValue)) {
         
         msgList.push({
            name: `bikeMarketValue`,
            message: `Please specify the market value of the bike`
         });
      } else if(!isValidPositiveNumber(data.bikeMarketValue, false)) {
      
         msgList.push({
            name: `bikeMarketValue`,
            message: `The market value of the bike must be a valid number!`
         });
         
      }
      
      if(isNotStringOrEmptyString(data.bikePurchaseDate)) {
         msgList.push({
            name: `bikePurchaseDate`,
            message: `Please specify the date the bike was purchased`
         });
      } else if(isDateGreaterThenToday(data.bikePurchaseDate)) {
         
         msgList.push({
            name: `bikePurchaseDate`,
            message: `The date the bike was purchased cannot be in the future!`
         });
         
      }
      
      if(isNotStringOrEmptyString(data.bikeRegistrationDate)) {
         msgList.push({
            name: `bikeRegistrationDate`,
            message: `Please specify the date the bike was registered`
         });
      } else if(isDateGreaterThenToday(data.bikeRegistrationDate)) {
         
         msgList.push({
            name: `bikeRegistrationDate`,
            message: `The date the bike was registered cannot be in the future!`
         })
      }
      
      if(!isInLabelValueArrayAsString(data.registeredOwner,MOTOR_CYCLE_OWNER_OPTIONS)) {
         msgList.push({
            name: `registeredOwner`,
            message: `Please specify the registered owner of the bike`
         });
      }
      
      if(!isInLabelValueArrayAsString(data.registeredKeeper,MOTOR_CYCLE_KEEPER_OPTIONS)){
         msgList.push({
            name: `registeredKeeper`,
            message: `Please specify the registered keeper of the bike`
         });
      }
      
      if(!isInLabelValueArrayAsString(data.bikeParkingAtHomeAddress,MOTOR_CYCLE_PARKING_OPTIONS)) {
         msgList.push({
            name: `bikeParkingAtHomeAddress`,
            message: `Please specify where the bike is parked at home address`
         });
      }
      
      if(!isInLabelValueArrayAsString(data.isBikeKeptOvernight,YES_NO_CHOICE_OPTIONS)) {
         msgList.push({
            name: `isBikeKeptOvernight`,
            message: `Please specify if the bike is kept at your address overnight`
         });
      }
      
      if(isNotStringOrEmptyString(data.currentMileage)) {
         msgList.push({
            name: `currentMileage`,
            message: `Please specify the current mileage of the bike`
         });
      }
      
      if(isNotStringOrEmptyString(data.annualMileage)) {
         msgList.push({
            name: `annualMileage`,
            message: `Please specify the annual mileage of the bike`
         });
      }
      
      if(isNotStringOrEmptyString(data.annualBusinessMileage)) {
         msgList.push({
            name: `annualBusinessMileage`,
            message: `Please specify the annual business mileage of the bike`
         });
      }
      
      if(!isInLabelValueArrayAsString(data.willCarryPillionPassengers,YES_NO_CHOICE_OPTIONS)) {
         msgList.push({
            name: `willCarryPillionPassengers`,
            message: `Please specify if the bike will carry pillion passengers`
         });
      }
      
      if(!isInLabelValueArrayAsString(data.willBeUsedForToeing,YES_NO_CHOICE_OPTIONS)) {
         msgList.push({
            name: `willBeUsedForToeing`,
            message: `Please specify if the bike will be used for towing`
         });
      }

    return msgList;

}